import { useFrameCountQuery } from '@/hook';
import { SwapHoriz, VButton } from '@/package';
import { useAuthStore } from '@/store';
import type { Task } from '@/type';

import { ReviewerHandoffModalController } from './ReviewerHandoffModalController';

export const ReviewerHandoffAllButton = ({ task }: { task: Task }) => {
  const { user, isManager } = useAuthStore();
  const { data: assignedCount } = useFrameCountQuery({
    taskID: task.id,
    workState: ['Reviewing'],
    reviewerID: [user.id],
  });

  return (
    <ReviewerHandoffModalController handoffType="all" taskID={task.id}>
      <VButton
        disabled={!assignedCount || !isManager()}
        outlined
        size="md"
        type="button"
        variant="secondary"
      >
        <SwapHoriz />
        All({assignedCount})
      </VButton>
    </ReviewerHandoffModalController>
  );
};

ReviewerHandoffAllButton.displayName = 'ReviewerHandoffAllButton';
